/**
 * Available betslip layouts
 */
export const BETSLIP_LAYOUTS = /** @type {const} */ ({
	TABS: 1,
	EUROPEAN: 2,
	US: 3,
});

/**
 * Available betslip mode types used in betslip
 */
export const BETSLIP_TYPES = /** @type {const} */({
	COMBI: 1,
	SINGLE: 2,
	SYSTEM: 3,
});

/**
 * Betslip type names
 */
export const BETSLIP_TYPE_NAMES = {
	COMBI: 'Mobile.combiBetslip',
	SINGLE: 'Mobile.Single',
	SYSTEM: 'Mobile.systemBetslip'
};
/**
 * Betslip game mode
 * We need to check each game what type is it and properly set BetMode property
 */
export const BETSLIP_GAME_MODES = /** @type {const} */({
	PRE_LIVE: 0,
	LIVE: 1,
	VFL: 2,
	VHC: 3,
	VDR: 4,
	JACKPOT: 5,
	MIXED: 6,
	FREEBET: 7,
});
/**
 * Platforms on which app is running
 */
export const PLATFORMS = /** @type {const} */ ({
	WEB: 0,
	MOBILE: 1,
	ONLINE_SHOP: 2,
});

/**
 * Betslip Item Types
 */
export const ITEM_TYPES = /** @type {const} */({
	PRE_MATCH: 1,
	LIVE: 2,
	VIRTUAL_FOOTBALL: 3,
	VIRTUAL_HORSE: 4,
	VIRTUAL_DOGS: 5,
	PLAYER: 6,
	OUTRIGHT: 7,
	VIRTUAL_TENNIS: 8,
	VIRTUAL_BASKETBALL: 9,
	BET_BUILDER: 10,
	BOOSTED_ODD: 11,
	LIVE_PLAYER_SWISH: 12,
	ALGO: 13,
});

export const BETSLIP_STATUS = /** @type {const} */({
	PLACED: 0,
	WON: 1,
	LOST: 2,
	PENDING: 4,
	PAID: 7,
	VOID: 9,
	CACHEDOUT: 12,
	REJECTED: 5,
	JACKPOTWON: 13,
	JACKPOTLOST: 14,
	CANCELLED: 3,
	HALFWON: 10,
	HALFLOST: 11,
});

/**
 * Betslip settings keys explained
 */
export const BETSLIP_SETTINGS = /** @type {const} */({
	MIN_BET_AMOUNT: 1,
	MAX_BET_AMOUNT: 2,
	DEFAULT_CURRENCY: 35,
	MAX_GAMES_COUNT: 53,
	MULTIPLE_SAME_MATCH_MARKETS: 65,
	USE_RESERVATION_CODE: 114,
	MAX_COMBS: 149,
	MAX_OUTCOMES_COUNT: 150,
	USE_FREEBET: 154,
	SCORECAST_ENABLED: 164,
	USE_CASHOUT: 166,
	MIN_LINE_AMOUNT: 177,
	MAX_LINE_AMOUNT: 178,
	CANCEL_BS_PERIOD: 104,
	BS_PAYOUT_TIMEOUT: 105,
	CAN_VIEW_LIVE_STREAM_WITHOUT_BALANCE: 192,
	BET_BUILDER_MARKET_ID: 208,
	BET_BUILDER_OUTCOME_ID: 209,
	BET_BUILDER_API_KEY: 210,
	SPORTCAST_API_URL: 217,
	ADD_STAKE_TAX: 222,
	BET_BUILDER_SWISH_MARKET_ID: 228,
	BET_BUILDER_SWISH_OUTCOME_ID: 229,
	CASHOUT_V2_ENABLE: 234,
	NO_BOOSTED_IN_FREEBETS: 263,
	ENABLE_FORECAST_TRICAST: 272,
	ALGO_ENABLED: 273,
	ONLY_SINGLES_FCTC: 278,
	ALGO_MARKET_ID: 275,
	ALGO_OUTCOME_ID: 276,
});

/**
 * Local storage key for betslip
 * @type {string}
 */
export const BETSLIP_STORAGE_KEY = 'betslip_v2';

/**
 * status codes used in betslip placement messages
 */
export const BETSLIP_MSG_STATUS =  /** @type {const} */({
	ERROR: -1,
	PLACED: 0,
	INVALID_USER: 1,
	PENDING: 4,
	REJECTED: 5,
	NO_FUNDS: 41,
	ITEMS_CHANGED: 43,
	MAX_PAYOUT_EXCEEDED: 55,
	INCOMPATIBLE_ITEMS: 56,
	TAKE_ACTION: -999,
	TRANSITION_TO_LIVE_ITEMS: 76
});


/**
 * Message types used in betslip message store for betslip info messages
 */
export const BETSLIP_MESSAGE_TYPE = /** @type {const} */({
	INFO: 'info',
	SUCCESS: 'success',
	WARNING: 'warning',
	ERROR: 'error',
});

export const BETSLIP_MESSAGE_KEY = /** @type {const} */({
	STAKE: 'stake_message',
	STAKE_LIMIT: 'stake_limit',
	LOGIN: 'login_message',
	PLACEMENT_MESSAGE: 'placement_message',
	BET_BUILDER: 'bet_builder_message',
});

export const BETSLIP_VALIDATION_ERRORS = /** @type {const} */({
	MAX_ITEMS: 1,
	SAME_MATCH: 2,
	BOOSTED_IN_FREEBET: 3,
	BOOSTED_SAME_MATCH: 4,
});

export const BETSLIP_SEARCH_TYPE = /** @type {const} */({
	BOOK: 1,
	BET_CHECK: 2,
});

export const ASSISTED_BET_OPTIONS = /** @type {const} */({
	username: { name: 'Mobile.username', code: 1, paramName: 'searchUserName' },
	civilID: { name: 'A.civilID', code: 2, paramName: 'searchCivilID' },
	fullName: { name: 'A.fullName', code: 3, paramName: 'searchFullName' },
	mobileNumber: { name: 'A.phone', code: 4, paramName: 'mobileNumber' },
});

/**
 * Quickbet classes for use in odds components
 */
const QUICKBET_CLASS = /** @type {const} */({
	PLACED: process.env.VUE_APP_IS_MOBILE ? 'bto-sb-mb-odd-quick' : 'bto-sb-odd-quick',
	ERROR: process.env.VUE_APP_IS_MOBILE ? 'bto-sb-mb-odd-quick bto-sb-mb-odd-quick-cancel' : 'bto-sb-odd-quick bto-sb-odd-quick-cancel',
	CHANGED: process.env.VUE_APP_IS_MOBILE ? 'bto-sb-mb-odd-quick bto-sb-mb-odd-quick-changed' : 'bto-sb-odd-quick bto-sb-odd-quick-changed',
});

/**
 * Map of betslip message statuses -> quckbet classes
 */
export const PLACE_STATUS_TO_QUICKBET_CLASS = /** @type {const} */({
	[BETSLIP_MSG_STATUS.PENDING]: QUICKBET_CLASS.PLACED,
	[BETSLIP_MSG_STATUS.PLACED]: QUICKBET_CLASS.PLACED,
	[BETSLIP_MSG_STATUS.ERROR]: QUICKBET_CLASS.ERROR,
	[BETSLIP_MSG_STATUS.INCOMPATIBLE_ITEMS]: QUICKBET_CLASS.ERROR,
	[BETSLIP_MSG_STATUS.INVALID_USER]: QUICKBET_CLASS.ERROR,
	[BETSLIP_MSG_STATUS.REJECTED]: QUICKBET_CLASS.ERROR,
	[BETSLIP_MSG_STATUS.ITEMS_CHANGED]: QUICKBET_CLASS.CHANGED,
});

/**
 * Line description
 */
export const SWISH_ODDS_LINE = /** @type {const}*/({
	OVER: 'over',
	UNDER: 'under',
});

/**
 * Accept odd change type enums
 */
export const BETSLIP_ACCEPT_ODD_TYPE = /** @type {const} */({
	ALL: 1,
	HIGHER: 2,
	LOWER: 3,
	NO: 4,
});